import React, {
  useEffect,
  useCallback,
  useRef,
  useMemo,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { isArray, isEmpty, isUndefined, includes, isNumber } from 'lodash';
import { parse, format } from 'date-fns';

import { Tabs } from '~/components';
import { t } from '~/helpers';

import {
  changeDaysWeek,
  changeBlockDates,
  changeCounties,
  changeQuotas,
  resetValues,
  changeCountiesProduts
} from '~/store/modules/organRegistration/actions';

import { ADM, GFO, GFE } from '~/constants/perfil';
import api from '~/services/api';

import ComponentDados from '../components/Dados';
import ComponentParametros from '../components/Parametros';
import ComponentCotas from '../components/Cota';

export default function FormOrgan({
  data,
  diasLiberacao,
  datasBloqueio,
  municipios,
  municipioprodutos,
  cotas,
  sending,
  close,
}) {
  const tabRef = useRef(null);
  const dispatch = useDispatch();

  const [initials, setInitials] = useState(data);


  // const { data } = useSelector((state) => state.orgao);
  const userInfo = useSelector((state) => state.user);


  //const { gloperfilid } = userInfo.profile

  const { glousuariotipo, gloperfilid } = useSelector(
    (state) => state.user.profile
  );



  const { daysWeek, blockDates, counties, quotas, countiesProduts } = useSelector(
    (state) => state.organRegistration
  );

  const RFields = useMemo(() => includes([ADM, GFO, GFE], gloperfilid), [
    gloperfilid,
    ADM,
    GFO,
    GFE,
  ]);

  const dataValidation = useMemo(
    () => ({
      orga_codigo: Yup.number()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .typeError(t('s.geral.validacao.campoobrigatorio')),
      orga_nome: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
        .typeError(t('s.geral.validacao.campoobrigatorio')),
      orga_cgc: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .max(14, t('s.geral.validacao.tamanhomaximo').replace('%s', 14))
        .typeError(t('s.geral.validacao.campoobrigatorio')),
      orga_status: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .typeError(t('s.geral.validacao.campoobrigatorio')),
      orga_endereco_cobranca: RFields
        ? Yup.string().nullable()
        : Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(200, t('s.geral.validacao.tamanhomaximo').replace('%s', 200))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      orga_municipio_cobranca: RFields
        ? Yup.string().nullable()
        : Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      orga_responsavel_issqn: RFields
        ? Yup.string().nullable()
        : Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
    }),
    [RFields]
  );

  const parametersValidation = useMemo(
    () => ({
      orga_transacoes: Yup.number()
        .nullable()
        .transform((_, value) => value || null)
        .when('orga_tipo_transacao', {
          is: (value) => value !== 0,
          then: Yup.number()
            .nullable(false)
            .typeError('Este campo deve conter um valor')
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, 'O valor da Transação deve ser maior que 0'),
        }),
      orga_intervalo: Yup.number()
        .nullable()
        .transform((_, value) => value || null)
        .when('orga_tipo_intervalo', {
          is: (value) => value !== 0,
          then: Yup.number()
            .nullable(false)
            .typeError('Este campo deve conter um valor')
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, 'O valor da Transação deve ser maior que 0'),
        }),
    }),
    []
  );

  const tabs = useMemo(
    () => {

      let dataOrgao = data;

      if (includes([ADM, GFE], glousuariotipo)) {
        return [
          {
            label: 'Dados',
            component: ComponentDados,
            validate: dataValidation,
          },
          {
            label: 'Parâmetros',
            component: (props) => <ComponentParametros dataOrgao={dataOrgao} {...props} />,
            validate: parametersValidation,
          },

          {
            label: 'Cota',
            component: () => (
              <ComponentCotas
                organ={data ? data.orga_codigo : 0}
              />
            ),
          },

        ]

      }

      return [
        {
          label: 'Dados',
          component: ComponentDados,
          validate: dataValidation,
        },
        {
          label: 'Parâmetros',
          component: (props) => <ComponentParametros dataOrgao={dataOrgao} {...props} />,
          validate: parametersValidation,
        }
      ]
    },
    [dataValidation, parametersValidation, data, ADM, GFE, glousuariotipo]
  );

  const handleSubmit = useCallback(async (value) => {
    try {

      // Validação  - ABASTECER SOMENTE NOS DIAS DA SEMANA
      //  console.log('9989 - handleSubmit' + JSON.stringify(value))

      // Validação  - ABASTECER SOMENTE NOS DIAS DA SEMANA
      let daysWeekErrs = [];
      value.params.daysWeek.forEach((date) => {
        if (date.error) {
          let dayOfWeek = '';
          switch (date.day) {
            case 1:
              dayOfWeek = 'Domingo';
              break;
            case 2:
              dayOfWeek = 'Segunda';
              break;
            case 3:
              dayOfWeek = 'Terça';
              break;
            case 4:
              dayOfWeek = 'Quarta';
              break;
            case 5:
              dayOfWeek = 'Quinta';
              break;
            case 6:
              dayOfWeek = 'Sexta';
              break;
            case 7:
              dayOfWeek = 'Sábado';
              break;
          }
          daysWeekErrs.push(`(ABASTECER SOMENTE NOS DIAS DA SEMANA)
           ${dayOfWeek} - Erro: Data Inválida !
         `);
        }
      });

      if (!isEmpty(daysWeekErrs)) {
        throw daysWeekErrs;
      }
      console.log(value)
      let formData = {
        orgao: {
          ...value.fields,
          orga_bloqueio_inadimplencia_observacao:
            value.fields.orga_bloqueio_inadimplencia === 'N'
              ? ''
              : value.fields.orga_bloqueio_inadimplencia_observacao,
        },
        datasBloqueio: value.params.blockDates.map((block) => ({
          orga_codigo: value.fields.orga_codigo,
          odbl_data: `${block.date} 00:00:00`,
          usua_login_rep_orgao_db_band: block.perfil_cad,
        })),
        // favor não alterar a data de 01/01/2000 por funções do backend !!!!!!
        diasLiberacao: value.params.daysWeek.map((day) => ({
          orga_codigo: value.fields.orga_codigo,
          odli_dia: day.day,
          odli_hora_fim: format(
            parse(day.final, 'HH:mm', new Date('01/01/2000')), // favor não alterar a data de 01/01/2000 por funções do backend
            'dd/MM/yyyy HH:mm:ss'
          ),
          odli_hora_ini: format(
            parse(day.initial, 'HH:mm', new Date('01/01/2000')), // favor não alterar a data de 01/01/2000 por funções do backend
            'dd/MM/yyyy HH:mm:ss'
          ),
          usua_login_rep_orgao_dl_asndds: day.perfil_cad
        })),
        municipios: value.params.counties.map((county) => ({
          orga_codigo: value.fields.orga_codigo,
          muni_codigo: county.muni_codigo,
          muni_nome: county.muni_nome,
          usua_login_rep_orgao_m_mlpa: county.perfil_cad
        })),
        municipioprodutos: value.params.countiesProduts.map((countiesprodut) => ({
          orga_codigo: value.fields.orga_codigo,
          muni_codigo: countiesprodut.muni_codigo,
          muni_nome: countiesprodut.muni_nome,
          prod_codigo: countiesprodut.prod_codigo,
          prod_descricao: countiesprodut.prod_descricao,
          usua_login_rep_orgao_m_mlpa: countiesprodut.perfil_cad,
        })),

        cotas: value.params.quotas.map((value) => ({
          orga_codigo: value.orga_codigo,
          prod_codigo: value.prod_codigo,
          prod_descricao: value.prod_descricao,
          coor_cota: value.coor_cota,
          coor_saldo: isNumber(value.coor_saldo) ? value.coor_saldo : String(value.novo_coor_saldo),
          cota_total: isNumber(value.cota_total) ? value.cota_total : String(value.novo_cota_total),
          coor_justificativa: value.coor_justificativa,
          usua_login_rep_cota_orga: value.perfil_cad
        })),


      };

      if (value.fields.orga_tipo_transacao != data.orga_tipo_transacao || value.fields.orga_transacoes != data.orga_transacoes) {
        formData.orgao = { ...formData.orgao, usua_login_rep_orgao_lapt: userInfo.profile.glousuariologin }
      }

      if (value.fields.orga_tipo_intervalo != data.orga_tipo_intervalo || value.fields.orga_intervalo != data.orga_intervalo) {
        formData.orgao = { ...formData.orgao, usua_login_rep_orgao_lapi: userInfo.profile.glousuariologin }
      }

      if (value.fields.orga_tipo_transacao == 0) {
        formData.orgao = { ...formData.orgao, orga_transacoes: 0 }
      }
      if (value.fields.orga_tipo_intervalo == 0) {
        formData.orgao = { ...formData.orgao, orga_intervalo: 0 }
      }

      await api.put('orgaos', formData);

      toast.success('Órgão atualizado com sucesso!');

      dispatch(resetValues());
      setInitials({});
      close();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data, userInfo]);

  useEffect(() => {
    if (sending) tabRef.current.onValidate();
  }, [sending]);

  useEffect(() => {
    if (!isEmpty(diasLiberacao))
      dispatch(
        changeDaysWeek(
          diasLiberacao.map((day) => {
            return {
              day: day.odli_dia,
              error: false,
              final: format(
                parse(day.odli_hora_fim, 'dd/MM/yyyy HH:mm:ss', new Date()),
                'HH:mm'
              ),
              initial: format(
                parse(day.odli_hora_ini, 'dd/MM/yyyy HH:mm:ss', new Date()),
                'HH:mm'
              ),
              perfil_cad: day.usua_login_rep_orgao_dl_asndds,
              perfil_tipo: day.usua_login_rep_orgao_dl_asndds_perf_tipo,
              perfil_desc: day.usua_login_rep_orgao_dl_asndds_perf_descricao,
            }
          })
        )
      );
  }, [diasLiberacao]);

  useEffect(() => {
    if (!isEmpty(datasBloqueio))
      dispatch(
        changeBlockDates(
          datasBloqueio.map((block) => ({
            date: format(
              parse(block.odbl_data, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'dd/MM/yyyy'
            ),
            perfil_cad: block.usua_login_rep_orgao_db_band,
            perfil_tipo: block.usua_login_rep_orgao_db_band_perf_tipo,
            perfil_desc: block.usua_login_rep_orgao_db_band_perf_descricao,

          }))
        )
      );
  }, [datasBloqueio]);

  useEffect(() => {
    if (!isEmpty(municipios)) {
      dispatch(
        changeCounties(
          municipios.map((countie) => ({
            ...countie,
            perfil_cad: countie.usua_login_rep_orgao_m_mlpa,
            perfil_tipo: countie.usua_login_rep_orgao_m_mlpa_perf_tipo,
            perfil_desc: countie.usua_login_rep_orgao_m_mlpa_perf_descricao,

          }))
        )
      );
    }

  }, [municipios]);


  useEffect(() => {
    if (!isEmpty(municipioprodutos))
      dispatch(
        changeCountiesProduts(
          municipioprodutos.map((muni) => ({
            ...muni,
            perfil_cad: muni.usua_login_rep_orgao_m_mlpa,
            perfil_tipo: muni.usua_login_rep_orgao_m_mlpa_perf_tipo,
            perfil_desc: muni.usua_login_rep_orgao_m_mlpa_perf_descricao,
          }))
        )
      );
  }, [municipioprodutos]);


  useEffect(() => {
    if (!isEmpty(cotas)) {
      dispatch(
        changeQuotas(
          cotas.map((cota) => ({
            ...cota,
            perfil_cad: cota.usua_login_rep_cota_orga,
            perfil_tipo: cota.usua_login_rep_cota_orga_perf_codigo,
            perfil_desc: cota.usua_login_rep_cota_orga_perf_descricao,
          })
          )
        ))
    }

  }, [cotas]);

  useEffect(() => {
    setInitials(isUndefined(data) ? {} : data);
  }, [data]);

  if (isEmpty(initials)) return 'Carregando...';

  return (
    <Tabs
      ref={tabRef}
      color="default"
      indicatorColor="primary"
      textColor="primary"
      initials={{
        orga_responsavel_issqn: 'T',
        orga_status: 'A',
        orga_retem_issqn: 'S',
        orga_bloqueio_inadimplencia: 'N',
        orga_tipo_transacao: 0,
        orga_transacoes: 0,
        orga_tipo_intervalo: 0,
        orga_intervalo: 0,
        ...initials,
      }}
      tabs={tabs}
      getData={handleSubmit}
      params={{ daysWeek, blockDates, counties, quotas, countiesProduts }}
    />
  );
}

FormOrgan.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  diasLiberacao: PropTypes.arrayOf(PropTypes.any).isRequired,
  datasBloqueio: PropTypes.arrayOf(PropTypes.any).isRequired,
  municipios: PropTypes.arrayOf(PropTypes.any).isRequired,
  municipioprodutos: PropTypes.arrayOf(PropTypes.any).isRequired,
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
